import React from "react";
import "./CloseOutDetails.scss";

export const FOUND_VIA = [
  { id: "found_via_bls", label: "Through a BLS introduction" },
  { id: "found_via_mls", label: "Through the MLS" },
  { id: "found_other", label: "Another way" },
];

// Cents are dropped (not concatenated): "450000.00" must stay 450000.
export const digitsOnly = (value) =>
  String(value || "")
    .split(".")[0]
    .replace(/[^0-9]/g, "")
    .slice(0, 10);
const withCommas = (value) =>
  digitsOnly(value).replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const FoundStep = ({
  reason,
  onReason,
  accepted,
  contextState,
  introductionId,
  onIntroduction,
  onContinue,
  onRetry,
}) => {
  const needsPick =
    reason === "found_via_bls" && accepted.length > 1 && !introductionId;
  return (
    <>
      <h2 className="close-out-title" id="close-out-title">
        Closed. How did your buyer find a home?
      </h2>
      <fieldset className="close-out-choices">
        <legend className="visually-hidden">How the home was found</legend>
        {FOUND_VIA.filter(
          (f) =>
            f.id !== "found_via_bls" ||
            contextState !== "ready" ||
            accepted.length > 0,
        ).map((f) => {
          const isBls = f.id === "found_via_bls";
          const disabled = isBls && contextState !== "ready";
          return (
            <label
              key={f.id}
              className={`close-out-choice${disabled ? " is-disabled" : ""}`}
            >
              <input
                type="radio"
                name="found-via"
                value={f.id}
                checked={reason === f.id}
                disabled={disabled}
                onChange={() => onReason(f.id)}
              />
              <span>{f.label}</span>
            </label>
          );
        })}
      </fieldset>
      {contextState === "error" && (
        <p className="close-out-error" role="status">
          Couldn't load your introductions, so we can't credit one.{" "}
          <button
            type="button"
            className="close-out-text-button"
            onClick={onRetry}
          >
            Retry
          </button>
        </p>
      )}
      {reason === "found_via_bls" && accepted.length > 1 && (
        <div className="close-out-field">
          <label htmlFor="close-out-intro">Which introduction helped?</label>
          <select
            id="close-out-intro"
            value={introductionId}
            onChange={(e) => onIntroduction(e.target.value)}
          >
            <option value="">Choose a listing</option>
            {accepted.map((a) => (
              <option key={a.introductionId} value={a.introductionId}>
                {[a.listingAddress, a.senderName]
                  .filter(Boolean)
                  .join(", from ")}
              </option>
            ))}
          </select>
        </div>
      )}
      <div className="close-out-actions">
        <button
          type="button"
          className="btn btn-primary close-out-primary"
          onClick={onContinue}
          disabled={!reason || needsPick}
        >
          Continue
        </button>
      </div>
    </>
  );
};

const DateField = ({ id, label, value, onChange }) => (
  <div className="close-out-field">
    <label htmlFor={id}>{label}</label>
    <input id={id} type="date" value={value || ""} onChange={onChange} />
  </div>
);

export const DetailsStep = ({
  reason,
  details,
  onChange,
  onSave,
  onSkip,
  busy,
}) => {
  const isPending = reason === "under_contract";
  const set = (key) => (e) => onChange({ ...details, [key]: e.target.value });
  return (
    <>
      <h2 className="close-out-title" id="close-out-title">
        {isPending ? "Under Contract" : "Closing details"}
      </h2>
      {isPending ? (
        <DateField
          id="close-out-expected"
          label="Expected closing date"
          value={details.expectedCloseDate}
          onChange={set("expectedCloseDate")}
        />
      ) : (
        <>
          <div className="close-out-field">
            <label htmlFor="close-out-address">Address of the home</label>
            <input
              id="close-out-address"
              type="text"
              autoComplete="off"
              value={details.propertyAddress || ""}
              onChange={set("propertyAddress")}
            />
          </div>
          <div className="close-out-field close-out-field--price">
            <label htmlFor="close-out-price">Purchase price</label>
            <span className="close-out-prefix" aria-hidden="true">
              $
            </span>
            <input
              id="close-out-price"
              type="text"
              inputMode="numeric"
              value={withCommas(details.purchasePrice)}
              onChange={(e) =>
                onChange({
                  ...details,
                  purchasePrice: digitsOnly(e.target.value),
                })
              }
            />
          </div>
          <DateField
            id="close-out-closed"
            label="Closing date"
            value={details.closedDate}
            onChange={set("closedDate")}
          />
        </>
      )}
      <div className="close-out-actions">
        <button
          type="button"
          className="btn btn-primary close-out-primary"
          onClick={onSave}
          disabled={!!busy}
        >
          {busy ? "Saving..." : "Save"}
        </button>
        <button
          type="button"
          className="close-out-text-button"
          onClick={onSkip}
          disabled={!!busy}
        >
          Skip
        </button>
      </div>
    </>
  );
};
